/**
 * Burly Bottom Designs - Gay Archetype Quiz
 * Handles quiz flow, scoring, and design filtering
 */

class BurlyQuiz {
  constructor() {
    this.currentQuestion = 0;
    this.scores = {
      1: 0, // Leather Daddy
      2: 0, // Tropical Slut
      3: 0, // Circuit Queen
      4: 0, // Country Slut
      5: 0, // Wholesome Ho
      6: 0, // Meme Lord
      7: 0, // Pup
      8: 0  // Fantasy Freak
    };
    this.currentLang = 'en';
    this.contentFilter = 'sfw'; // Default to SFW only
    this.archetypeData = null;
    this.designData = null;
    this.winningArchetype = null;
    this.oppositeArchetype = null;
    
    this.init();
  }

  init() {
    // Load archetype data from embedded JSON
    const dataElement = document.querySelector('[data-archetype-data]');
    if (dataElement) {
      const data = JSON.parse(dataElement.textContent);
      this.archetypeData = data.archetypes;
    }

    // Bind event listeners
    this.bindEvents();
    
    // Fetch design data from Shopify
    this.fetchDesigns();
    
    // Check if we're loading a shared result (wait for archetype data first)
    if (this.archetypeData) {
      this.checkForSharedResult();
    } else {
      // If archetypeData not loaded yet, wait for it
      const checkData = setInterval(() => {
        if (this.archetypeData) {
          clearInterval(checkData);
          this.checkForSharedResult();
        }
      }, 50);
    }
  }
  
  checkForSharedResult() {
    // Check for result page div
    const resultData = document.getElementById('archetype-result-data');
    
    console.log('Checking for shared result...', resultData);
    
    if (resultData) {
      const archetypeId = parseInt(resultData.dataset.archetypeId);
      console.log('Found archetype ID:', archetypeId);
      console.log('Available archetypes:', this.archetypeData);
      
      const archetype = this.archetypeData.find(a => a.id === archetypeId);
      
      if (archetype) {
        console.log('Matched archetype:', archetype);
        this.winningArchetype = archetype;
        const opposites = this.archetypeData.filter(a => a.id !== archetypeId);
        this.oppositeArchetype = opposites[Math.floor(Math.random() * opposites.length)];
        this.isSharedResult = true;
        
        const checkDesigns = setInterval(() => {
          if (this.designData && this.designData.length > 0) {
            console.log('Designs loaded, showing result');
            clearInterval(checkDesigns);
            this.showSharedResult();
          }
        }, 100);
      } else {
        console.error('Could not find archetype with ID:', archetypeId);
      }
    } else {
      console.log('No result data found, showing normal quiz start');
    }
  }
  
  showSharedResult() {
    this.showScreen('results');
    this.renderArchetypeResult(this.winningArchetype);
    this.renderDesigns(this.winningArchetype, 'vibe', null);
    this.renderDesigns(this.oppositeArchetype, 'opposite', this.winningArchetype);
    
    // Show "Take Quiz Yourself" button instead of "Retake"
    const retakeBtn = document.querySelector('[data-quiz-retake]');
    if (retakeBtn && this.isSharedResult) {
      retakeBtn.textContent = 'Take the Quiz Yourself';
    }
  }

  bindEvents() {
    // Start quiz button
    const startBtn = document.querySelector('[data-quiz-start]');
    if (startBtn) {
      startBtn.addEventListener('click', () => this.startQuiz());
    }

    // Retake quiz button
    const retakeBtn = document.querySelector('[data-quiz-retake]');
    if (retakeBtn) {
      retakeBtn.addEventListener('click', () => this.retakeQuiz());
    }

    // Language toggle
    const langButtons = document.querySelectorAll('[data-lang]');
    langButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.currentLang = e.target.dataset.lang;
        this.updateLanguage();
        
        // Update active state
        langButtons.forEach(b => b.classList.remove('active'));
        e.target.classList.add('active');
      });
    });

    // Content filter toggle
    const filterButtons = document.querySelectorAll('[data-filter]');
    filterButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        this.contentFilter = e.target.dataset.filter;
        
        // Update active state
        filterButtons.forEach(b => b.classList.remove('active'));
        e.target.classList.add('active');
        
        // Re-render designs with new filter
        if (this.winningArchetype && this.oppositeArchetype) {
          this.renderDesigns(this.winningArchetype, 'vibe', null);
          this.renderDesigns(this.oppositeArchetype, 'opposite', this.winningArchetype);
        }
      });
    });

    // Share buttons
    const facebookBtn = document.querySelector('[data-share-facebook]');
    if (facebookBtn) {
      facebookBtn.addEventListener('click', () => this.shareToFacebook());
    }
    
    const twitterBtn = document.querySelector('[data-share-twitter]');
    if (twitterBtn) {
      twitterBtn.addEventListener('click', () => this.shareToTwitter());
    }
    
    const redditBtn = document.querySelector('[data-share-reddit]');
    if (redditBtn) {
      redditBtn.addEventListener('click', () => this.shareToReddit());
    }
    
    const whatsappBtn = document.querySelector('[data-share-whatsapp]');
    if (whatsappBtn) {
      whatsappBtn.addEventListener('click', () => this.shareToWhatsApp());
    }
    
    const copyBtn = document.querySelector('[data-share-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => this.copyLink());
    }
  }

  async fetchDesigns() {
    // Fetch all designs from Shopify Storefront API with pagination
    let allDesigns = [];
    let hasNextPage = true;
    let cursor = null;
    
    while (hasNextPage) {
      const query = `{
        metaobjects(type: "design", first: 250${cursor ? `, after: "${cursor}"` : ''}) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            cursor
            node {
              id
              handle
              fields {
                key
                value
                reference {
                  ... on MediaImage {
                    image {
                      url
                      altText
                    }
                  }
                }
              }
            }
          }
        }
      }`;

      try {
        const response = await fetch('/api/2024-01/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': window.Shopify.storefrontAccessToken
          },
          body: JSON.stringify({ query })
        });

        const data = await response.json();
        
        if (data.data && data.data.metaobjects) {
          // Add this batch of designs to our collection
          const batchDesigns = this.parseDesignData(data);
          allDesigns = allDesigns.concat(batchDesigns);
          
          // Check if there are more pages
          hasNextPage = data.data.metaobjects.pageInfo.hasNextPage;
          cursor = data.data.metaobjects.pageInfo.endCursor;
          
          console.log(`Loaded ${allDesigns.length} designs so far...`);
        } else {
          hasNextPage = false;
        }
      } catch (error) {
        console.error('Error fetching designs:', error);
        hasNextPage = false;
      }
    }
    
    this.designData = allDesigns;
    console.log(`Finished loading all ${this.designData.length} designs`);
  }

  parseDesignData(apiResponse) {
    // Transform Shopify metaobject response into usable design objects
    if (!apiResponse.data || !apiResponse.data.metaobjects) {
      return [];
    }

    return apiResponse.data.metaobjects.edges.map(edge => {
      const fields = edge.node.fields;
      const design = {
        id: edge.node.id,
        handle: edge.node.handle,
        childTags: [],
        parentCategories: []
      };

      fields.forEach(field => {
        switch(field.key) {
          case 'design_name':
          case 'title':
            design.name = field.value;
            break;
          case 'design_image':
          case 'featured_image':
            design.image = field.reference?.image?.url || field.value;
            break;
          case 'body':
            design.description = field.value;
            break;
          case 'child_tags':
          case 'design_themes':
            // Parse JSON array of child tags / design themes
            try {
              design.childTags = JSON.parse(field.value || '[]');
            } catch(e) {
              design.childTags = [];
            }
            break;
          case 'rating':
            // Handle SFW/NSFW rating dropdown
            design.isSFW = field.value === 'SFW';
            design.isNSFW = field.value === 'NSFW';
            break;
        }
      });

      // Calculate parent categories based on child tags
      design.parentCategories = this.calculateParentCategories(design.childTags);

      return design;
    }).filter(design => {
      // Exclude designs with "Seasonal" theme
      return !design.childTags.includes('Seasonal');
    });
  }

  calculateParentCategories(childTags) {
    // For each child tag, find which parent categories it belongs to
    const parentSet = new Set();
    
    childTags.forEach(tag => {
      // Use the helper function from quiz-tag-map.js
      const parents = getParentCategories(tag);
      parents.forEach(parent => parentSet.add(parent));
    });

    return Array.from(parentSet);
  }

  startQuiz() {
    this.showScreen('questions');
    this.renderQuestion(0);
  }

  renderQuestion(index) {
    const questions = this.getQuestions();
    const question = questions[index];
    
    const container = document.querySelector('[data-questions-container]');
    
    container.innerHTML = `
      <div class="quiz-question fade-in" data-question="${index}">
        <h3 class="quiz-question__text">${question.text}</h3>
        <div class="quiz-answers">
          ${question.answers.map((answer, i) => `
            <button class="quiz-answer" data-answer="${i}">
              ${answer.text}
            </button>
          `).join('')}
        </div>
      </div>
    `;

    // Update progress
    this.updateProgress(index + 1, questions.length);

    // Bind answer buttons
    const answerBtns = container.querySelectorAll('[data-answer]');
    answerBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        const answerIndex = parseInt(e.target.dataset.answer);
        this.handleAnswer(question.answers[answerIndex].scores);
        
        // Add selection animation
        e.target.classList.add('selected');
        
        setTimeout(() => {
          if (index < questions.length - 1) {
            this.renderQuestion(index + 1);
          } else {
            this.showResults();
          }
        }, 300);
      });
    });
  }

  handleAnswer(scores) {
    // Add scores to archetypes
    scores.forEach(score => {
      this.scores[score.archetype] += score.points;
    });
  }

  showResults() {
    // Calculate winning and opposite archetypes
    this.winningArchetype = this.calculateWinner();
    this.oppositeArchetype = this.calculateOpposite();
    
    // Map archetype IDs to result page URLs
    const archetypeUrls = {
      1: '/pages/result-leather-daddy',
      2: '/pages/result-tropical-slut',
      3: '/pages/result-circuit-queen',
      4: '/pages/result-country-slut',
      5: '/pages/result-wholesome-ho',
      6: '/pages/result-meme-lord',
      7: '/pages/result-pup',
      8: '/pages/result-fantasy-freak'
    };
    
    // Redirect to the actual result page
    window.location.href = archetypeUrls[this.winningArchetype.id];
  }

  calculateWinner() {
    // Find archetype with highest score
    let maxScore = 0;
    let winnerId = 1;

    Object.entries(this.scores).forEach(([id, score]) => {
      if (score > maxScore) {
        maxScore = score;
        winnerId = parseInt(id);
      }
    });

    return this.archetypeData.find(a => a.id === winnerId);
  }

  calculateOpposite() {
    // Find archetype with LOWEST score
    let minScore = Infinity;
    let oppositeId = 1;

    Object.entries(this.scores).forEach(([id, score]) => {
      if (score < minScore) {
        minScore = score;
        oppositeId = parseInt(id);
      }
    });

    return this.archetypeData.find(a => a.id === oppositeId);
  }

  renderArchetypeResult(archetype) {
    const card = document.querySelector('[data-result-card]');
    const name = document.querySelector('[data-result-name]');
    const description = document.querySelector('[data-result-description]');

    // Animate card reveal with flip effect
    card.innerHTML = `<img src="${archetype.card_image}" alt="${archetype.name_en}" class="loteria-card__image">`;
    card.classList.add('card-reveal');
    
    name.textContent = archetype[`name_${this.currentLang}`];
    description.textContent = archetype[`description_${this.currentLang}`];
  }

  filterDesignsForArchetype(archetype, excludeArchetype = null) {
    if (!this.designData || this.designData.length === 0) {
      return [];
    }

    const archetypeParents = archetype.parent_categories || [];
    const archetypePriorityTags = archetype.priority_tags || [];

    // Filter: designs must match at least one parent category
    let matchingDesigns = this.designData.filter(design => {
      const hasMatchingParent = design.parentCategories.some(parent => 
        archetypeParents.includes(parent)
      );
      return hasMatchingParent;
    });

    // If this is for "opposite energy", exclude designs that match the winning archetype
    if (excludeArchetype) {
      const excludeParents = excludeArchetype.parent_categories || [];
      matchingDesigns = matchingDesigns.filter(design => {
        const matchesExclude = design.parentCategories.some(parent =>
          excludeParents.includes(parent)
        );
        return !matchesExclude;
      });
    }

    // Score each design by how many priority tags it has
    matchingDesigns = matchingDesigns.map(design => {
      const priorityMatches = design.childTags.filter(tag => 
        archetypePriorityTags.includes(tag)
      ).length;

      return {
        ...design,
        priorityScore: priorityMatches
      };
    });

    // Sort by priority score (highest first)
    matchingDesigns.sort((a, b) => b.priorityScore - a.priorityScore);

    return matchingDesigns;
  }

  renderDesigns(archetype, type, oppositeArchetype = null) {
    const container = document.querySelector(`[data-${type}-designs]`);
    
    if (!container) return;

    let designs;
    
    if (type === 'vibe') {
      // "Your Vibe" designs - match the archetype
      designs = this.filterDesignsForArchetype(archetype);
    } else {
      // "Opposite Energy" designs - match opposite archetype but exclude winning archetype
      designs = this.filterDesignsForArchetype(archetype, oppositeArchetype);
    }

    // Apply SFW/NSFW filter
    if (this.contentFilter === 'sfw') {
      designs = designs.filter(design => design.isSFW);
    }

    // Take top matches, then randomize within that pool for variety on retakes
    const topDesigns = designs.slice(0, 10); // Top 10 scoring designs
    const selectedDesigns = this.shuffleArray(topDesigns).slice(0, 3);

    if (selectedDesigns.length === 0) {
      container.innerHTML = '<p class="no-designs">No matching designs found. Try toggling to "All Designs" above.</p>';
      return;
    }

    container.innerHTML = selectedDesigns.map(design => `
      <div class="design-card">
        <div class="design-card__image">
          <img src="${design.image}" alt="${design.name}" loading="lazy">
        </div>
        <div class="design-card__content">
          <h4 class="design-card__name">${design.name}</h4>
          ${design.description ? `<p class="design-card__description">${design.description}</p>` : ''}
          <a href="/pages/design/${design.handle}" class="btn btn--small">
            View This Design
          </a>
        </div>
      </div>
    `).join('');
  }

  getShareData() {
    if (!this.winningArchetype) return null;
    
    const archetype = this.winningArchetype;
    const baseUrl = window.location.origin + window.location.pathname;
    const resultUrl = `${baseUrl}/result/${archetype.id}`;
    const shareText = `I'm ${archetype[`name_${this.currentLang}`]}! What Burly Bottom are you?`;
    
    return {
      url: resultUrl,
      text: shareText,
      fullText: `${shareText} ${resultUrl}`,
      image: archetype.card_image
    };
  }
  
  shareToFacebook() {
    const data = this.getShareData();
    if (!data) return;
    
    const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(data.url)}`;
    window.open(fbUrl, '_blank', 'width=600,height=400');
  }
  
  shareToTwitter() {
    const data = this.getShareData();
    if (!data) return;
    
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(data.text)}&url=${encodeURIComponent(data.url)}`;
    window.open(twitterUrl, '_blank', 'width=600,height=400');
  }
  
  shareToReddit() {
    const data = this.getShareData();
    if (!data) return;
    
    const redditUrl = `https://reddit.com/submit?url=${encodeURIComponent(data.url)}&title=${encodeURIComponent(data.text)}`;
    window.open(redditUrl, '_blank', 'width=600,height=700');
  }
  
  shareToWhatsApp() {
    const data = this.getShareData();
    if (!data) return;
    
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(data.fullText)}`;
    window.open(whatsappUrl, '_blank');
  }
  
  copyLink() {
    const data = this.getShareData();
    if (!data) return;
    
    // Copy ONLY the URL (not text + URL)
    navigator.clipboard.writeText(data.url)
      .then(() => {
        // Show success feedback
        const btn = document.querySelector('[data-share-copy]');
        const originalHTML = btn.innerHTML;
        btn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg> Copied!';
        btn.classList.add('copied');
        
        setTimeout(() => {
          btn.innerHTML = originalHTML;
          btn.classList.remove('copied');
        }, 2000);
      })
      .catch(err => console.error('Copy failed:', err));
  }

  updateLanguage() {
    // Re-render result text in selected language
    if (this.winningArchetype) {
      this.renderArchetypeResult(this.winningArchetype);
    }
  }

  updateProgress(current, total) {
    const progressBar = document.querySelector('[data-progress-bar]');
    const progressText = document.querySelector('[data-progress-text]');
    
    if (!progressBar || !progressText) return;
    
    const percent = (current / total) * 100;
    progressBar.style.width = `${percent}%`;
    progressText.textContent = `Question ${current} of ${total}`;
  }

  retakeQuiz() {
    // Reset scores
    Object.keys(this.scores).forEach(key => {
      this.scores[key] = 0;
    });
    
    this.currentQuestion = 0;
    this.winningArchetype = null;
    this.oppositeArchetype = null;
    this.isSharedResult = false;
    
    // Clear URL parameter
    window.history.pushState({}, '', window.location.pathname);
    
    this.startQuiz();
  }

  showScreen(screenName) {
    document.querySelectorAll('[data-screen]').forEach(screen => {
      screen.classList.remove('active');
    });
    
    const targetScreen = document.querySelector(`[data-screen="${screenName}"]`);
    if (targetScreen) {
      targetScreen.classList.add('active');
    }
  }

  shuffleArray(array) {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  }

  getQuestions() {
    // All 7 questions with scoring logic
    return [
      {
        text: "Pick your perfect Friday night",
        answers: [
          { 
            text: "Beach club, sunset cocktails, and shirtless strangers",
            scores: [
              { archetype: 2, points: 3 }, // Tropical Slut
              { archetype: 3, points: 1 }  // Circuit Queen
            ]
          },
          {
            text: "Leather bar, dark corner, no names exchanged",
            scores: [
              { archetype: 1, points: 3 }, // Leather Daddy
              { archetype: 7, points: 1 }  // Pup
            ]
          },
          {
            text: "Movie marathon with someone special (and snacks)",
            scores: [
              { archetype: 5, points: 3 }, // Wholesome Ho
              { archetype: 8, points: 1 }  // Fantasy Freak
            ]
          },
          {
            text: "Circuit party: lights, music, and zero inhibitions",
            scores: [
              { archetype: 3, points: 4 }
            ]
          },
          {
            text: "Bonfire, beers, and boys in flannels",
            scores: [
              { archetype: 4, points: 3 }, // Country Slut
              { archetype: 1, points: 1 }  // Leather Daddy
            ]
          },
          {
            text: "Gaming tournament (winner takes all... and bottom)",
            scores: [
              { archetype: 8, points: 3 }, // Fantasy Freak
              { archetype: 6, points: 1 }  // Meme Lord
            ]
          },
          {
            text: "Scrolling memes until 3 AM with pizza",
            scores: [
              { archetype: 6, points: 3 }, // Meme Lord
              { archetype: 5, points: 1 }  // Wholesome Ho
            ]
          }
        ]
      },
      {
        text: "What's in your gym bag?",
        answers: [
          { 
            text: "Gym bag? I'm naturally perfect",
            scores: [
              { archetype: 6, points: 3 },
              { archetype: 5, points: 1 }
            ]
          },
          {
            text: "Harness, boots, and unshakeable confidence",
            scores: [
              { archetype: 1, points: 3 },
              { archetype: 3, points: 1 }
            ]
          },
          {
            text: "Sunscreen, flip-flops, and a thirst trap ready outfit",
            scores: [
              { archetype: 2, points: 3 },
              { archetype: 3, points: 1 }
            ]
          },
          {
            text: "Work gloves and a Carhartt hat",
            scores: [
              { archetype: 4, points: 3 },
              { archetype: 1, points: 1 }
            ]
          },
          {
            text: "Full face of makeup and a change of shoes",
            scores: [
              { archetype: 3, points: 3 },
              { archetype: 6, points: 1 }
            ]
          },
          {
            text: "Collar, tail, and treats (for motivation)",
            scores: [
              { archetype: 7, points: 3 },
              { archetype: 1, points: 1 }
            ]
          },
          {
            text: "Dice set, character sheet, and emergency snacks",
            scores: [
              { archetype: 8, points: 3 },
              { archetype: 5, points: 1 }
            ]
          }
        ]
      },
      {
        text: "How do you flirt?",
        answers: [
          {
            text: "Eye contact that could start a fire",
            scores: [
              { archetype: 1, points: 3 },
              { archetype: 3, points: 1 }
            ]
          },
          {
            text: "Memes and innuendo until they laugh or block me",
            scores: [
              { archetype: 6, points: 3 },
              { archetype: 2, points: 1 }
            ]
          },
          {
            text: "I smile shyly and hope they notice",
            scores: [
              { archetype: 5, points: 4 },
              { archetype: 8, points: 1 }
            ]
          },
          {
            text: "I buy them a drink and tell them exactly what I want",
            scores: [
              { archetype: 2, points: 3 },
              { archetype: 1, points: 1 }
            ]
          },
          {
            text: "I do a cannonball into the pool near them",
            scores: [
              { archetype: 2, points: 3 },
              { archetype: 6, points: 1 }
            ]
          },
          {
            text: "I offer to teach them how to ride (a horse, obviously)",
            scores: [
              { archetype: 4, points: 3 },
              { archetype: 1, points: 1 }
            ]
          },
          {
            text: "I wag my tail and wait for headpats",
            scores: [
              { archetype: 7, points: 4 }
            ]
          },
          {
            text: "I quote their favorite movie until they fall in love",
            scores: [
              { archetype: 8, points: 3 },
              { archetype: 5, points: 1 }
            ]
          }
        ]
      },
      {
        text: "Your ideal vacation is...",
        answers: [
          {
            text: "Puerto Vallarta: sun, surf, and sin",
            scores: [
              { archetype: 2, points: 4 }
            ]
          },
          {
            text: "A cabin in the woods with one very special person",
            scores: [
              { archetype: 5, points: 3 },
              { archetype: 4, points: 2 }
            ]
          },
          {
            text: "Berlin: clubs, kink, and zero inhibitions",
            scores: [
              { archetype: 1, points: 3 },
              { archetype: 3, points: 1 }
            ]
          },
          {
            text: "Nashville: honky-tonks and hot cowboys",
            scores: [
              { archetype: 4, points: 3 },
              { archetype: 6, points: 1 }
            ]
          },
          {
            text: "Anywhere with good WiFi and better pizza",
            scores: [
              { archetype: 6, points: 3 },
              { archetype: 8, points: 1 }
            ]
          },
          {
            text: "Provincetown: rainbow flags and beach parties",
            scores: [
              { archetype: 3, points: 3 },
              { archetype: 2, points: 1 }
            ]
          },
          {
            text: "Comic-Con: costumes required, inhibitions optional",
            scores: [
              { archetype: 8, points: 3 },
              { archetype: 6, points: 1 }
            ]
          },
          {
            text: "A pup mosh at Folsom",
            scores: [
              { archetype: 7, points: 3 },
              { archetype: 1, points: 1 }
            ]
          }
        ]
      },
      {
        text: "What's your signature look?",
        answers: [
          {
            text: "Leather, harness, and a look that says \"try me\"",
            scores: [
              { archetype: 1, points: 3 },
              { archetype: 7, points: 1 }
            ]
          },
          {
            text: "Tank top, short shorts, and effortless sex appeal",
            scores: [
              { archetype: 2, points: 3 },
              { archetype: 3, points: 1 }
            ]
          },
          {
            text: "Flannel, jeans, and work boots (with a secret)",
            scores: [
              { archetype: 4, points: 4 }
            ]
          },
          {
            text: "Full glam: hair, makeup, nails, ATTITUDE",
            scores: [
              { archetype: 3, points: 3 },
              { archetype: 8, points: 1 }
            ]
          },
          {
            text: "Whatever's clean and makes me look cute",
            scores: [
              { archetype: 5, points: 3 },
              { archetype: 6, points: 1 }
            ]
          },
          {
            text: "Graphic tee with a dirty joke nobody gets",
            scores: [
              { archetype: 6, points: 3 },
              { archetype: 2, points: 1 }
            ]
          },
          {
            text: "Pup hood, harness, tail — the full package",
            scores: [
              { archetype: 7, points: 3 },
              { archetype: 1, points: 1 }
            ]
          },
          {
            text: "Cosplay that took 6 months to make",
            scores: [
              { archetype: 8, points: 3 },
              { archetype: 5, points: 1 }
            ]
          }
        ]
      },
      {
        text: "Pick your theme song",
        answers: [
          {
            text: "\"Padam Padam\" — Kylie Minogue",
            scores: [
              { archetype: 3, points: 4 }
            ]
          },
          {
            text: "\"Closer\" — Nine Inch Nails",
            scores: [
              { archetype: 1, points: 3 },
              { archetype: 7, points: 1 }
            ]
          },
          {
            text: "\"Before He Cheats\" — Carrie Underwood",
            scores: [
              { archetype: 4, points: 3 },
              { archetype: 6, points: 1 }
            ]
          },
          {
            text: "\"A Whole New World\" — Aladdin soundtrack",
            scores: [
              { archetype: 5, points: 4 },
              { archetype: 8, points: 1 }
            ]
          },
          {
            text: "\"Never Gonna Give You Up\" — Rick Astley (unironically)",
            scores: [
              { archetype: 6, points: 3 },
              { archetype: 5, points: 1 }
            ]
          },
          {
            text: "\"One-Winged Angel\" — Final Fantasy VII",
            scores: [
              { archetype: 8, points: 4 }
            ]
          },
          {
            text: "\"Who Let the Dogs Out\" — Baha Men",
            scores: [
              { archetype: 7, points: 3 },
              { archetype: 6, points: 1 }
            ]
          },
          {
            text: "\"Hot in Herre\" — Nelly",
            scores: [
              { archetype: 2, points: 3 },
              { archetype: 3, points: 1 }
            ]
          }
        ]
      },
      {
        text: "What's your relationship with feelings?",
        answers: [
          {
            text: "I have feelings? News to me",
            scores: [
              { archetype: 6, points: 3 },
              { archetype: 2, points: 2 }
            ]
          },
          {
            text: "I feel EVERYTHING and I'm not sorry",
            scores: [
              { archetype: 5, points: 3 },
              { archetype: 3, points: 1 }
            ]
          },
          {
            text: "Feelings are allowed after we negotiate the scene",
            scores: [
              { archetype: 1, points: 3 },
              { archetype: 7, points: 1 }
            ]
          },
          {
            text: "I express love through acts of service (and BJs)",
            scores: [
              { archetype: 4, points: 2 },
              { archetype: 5, points: 2 }
            ]
          },
          {
            text: "Feelings are for slow songs at 3 AM",
            scores: [
              { archetype: 3, points: 3 },
              { archetype: 2, points: 1 }
            ]
          },
          {
            text: "I cry during Pixar movies and I'm not ashamed",
            scores: [
              { archetype: 5, points: 4 },
              { archetype: 8, points: 1 }
            ]
          },
          {
            text: "My handler says I'm very emotionally intelligent (good boy!)",
            scores: [
              { archetype: 7, points: 4 }
            ]
          },
          {
            text: "I channel all emotions into my D&D character",
            scores: [
              { archetype: 8, points: 3 },
              { archetype: 6, points: 1 }
            ]
          }
        ]
      }
    ];
  }
}

// Initialize quiz when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.burlyQuiz = new BurlyQuiz();
});